var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48074 6.48074 2 12 2C17.5193 2 22 6.48074 22 12C22 17.5193 17.5193 22 12 22C6.48074 22 2 17.5193 2 12ZM20.5365 12C20.5365 7.28847 16.7115 3.46346 12 3.46346C7.28847 3.46346 3.46346 7.28847 3.46346 12C3.46346 16.7115 7.28847 20.5365 12 20.5365C16.7115 20.5365 20.5365 16.7115 20.5365 12ZM10.1431 15.3092C10.1175 15.3092 10.0925 15.2991 10.0743 15.2802C9.64075 14.8419 7.28314 12.4561 6.84999 12.0173C6.81236 11.9796 6.75025 11.9785 6.7118 12.0168C6.61759 12.1106 6.43989 12.2869 6.26219 12.4632C6.0845 12.6395 5.9068 12.8158 5.81259 12.9097C5.77453 12.9474 5.77375 13.0096 5.81138 13.0473C6.32455 13.5661 9.55215 16.8324 10.0649 17.3517C10.0836 17.37 10.1081 17.3806 10.1337 17.3806C10.1593 17.3807 10.1845 17.3706 10.2031 17.3522C10.5709 16.9864 12.3477 15.2203 14.1248 13.4539C15.9027 11.6868 17.6809 9.91931 18.0488 9.55332C18.0869 9.51559 18.0872 9.45394 18.0493 9.41512C17.9558 9.32088 17.78 9.1433 17.6042 8.96564C17.4279 8.78762 17.2516 8.60953 17.158 8.5151C17.1197 8.4768 17.0583 8.47633 17.0198 8.51458C16.342 9.18877 10.8911 14.6071 10.2121 15.2813C10.1938 15.2991 10.1694 15.3098 10.1431 15.3092Z",
    fill: "#00AD82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e8842e64b0b4312708373471e5aea00f.svg";
export { ForwardRef as ReactComponent };